import Education from '../components/Education';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import '../scss/pages/Resume.scss';
import Awards from '../components/Awards';
import React from 'react';

const Resume = () => {
  return (
    <>
      <Skills />
      <Experience />
      {/* <Awards /> */}
    </>
  );
};

export default Resume;
